import { useEffect, useState } from 'react';
import { McpConfig } from 'src/components/context/AppContextModels';
import { listMcpConfigs } from 'src/graphql/queries';
import { fetchGraphQLRequest } from 'src/api/graphql-api';
import { appSyncOperationName } from 'src/constants/AppConstants';
import { logger } from 'src/logger';

export const useMcpConfigs = () => {
  const [mcpConfigs, setMcpConfigs] = useState<McpConfig[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMcpConfigsData = async () => {
      try {
        const data = await fetchGraphQLRequest<{ listMcpConfigs: McpConfig[] }>({
          query: listMcpConfigs,
          variables: {},
          requestName: 'listMcpConfigs',
          requestType: appSyncOperationName.QUERY
        });
        setMcpConfigs(data.listMcpConfigs || []);
      } catch (error) {
        logger.error('Failed to fetch MCP configs.', { error });
      } finally {
        setIsLoading(false);
      }
    };

    fetchMcpConfigsData();
  }, []);

  return { mcpConfigs, isLoading, setMcpConfigs };
};
